module.exports = __webpack_public_path__ + "img/jt-3.d8a62a33.png";